export const MEDPLUM_BASE_URL = 'https://api.medplum.com'
export const MEDPLUM_PROJECT_ID = import.meta.env
  .VITE_MEDPLUM_PROJECT_ID as string
export const MEDPLUM_GOOGLE_CLIENT_ID = import.meta.env
  .VITE_MEDPLUM_GOOGLE_CLIENT_ID as string

export const SEEN_API_URL = import.meta.env.VITE_SEEN_API_URL as string
export const APP_VERSION = import.meta.env.VITE_APP_VERSION as string
export const APP_COMMIT_SHA = import.meta.env.VITE_APP_COMMIT_SHA as string

export const IS_DEV = __APP_ENV__ === 'development'
export const IS_STAGING = __APP_ENV__ === 'preview'
export const IS_PROD = __APP_ENV__ === 'production'
